<template>
    <div
        v-if="content.title"
        class="pb-2 px-4 pt-10 first:pt-5 border-b border-neutral-subtle text-gray-600 uppercase text-[13px] font-normal tracking-wide"
    >
        {{ content.title }}
    </div>
</template>

<script setup>
    const props = defineProps({
        config: Object,
    })

    const content = computed(() => (props.config ? props.config.data : null))
</script>
